mergeTrueFn